module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": "",
      "mb-2": ""
    }
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Canal de Reserva")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md3": "",
      "text-xs-left": ""
    }
  }, [_c('select-button', {
    attrs: {
      "autocomplete": "",
      "placeholder": "Tipo de Canal",
      "item-text": "name",
      "item-value": "id",
      "items": _vm.typeChannels
    },
    on: {
      "input": _vm.loadChannels
    },
    model: {
      value: (_vm.channel.typeChannelId),
      callback: function($$v) {
        _vm.channel.typeChannelId = $$v
      },
      expression: "channel.typeChannelId"
    }
  }), _vm._v(" "), (_vm.$v.channel.typeChannelId && _vm.$v.channel.typeChannelId.$invalid) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\t\tEl tipo de canal es requerido\n\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "md3": "",
      "text-xs-left": ""
    }
  }, [_c('select-button', {
    attrs: {
      "autocomplete": "",
      "placeholder": "Canal",
      "item-text": "inputSearch",
      "item-value": "id",
      "items": _vm.channels
    },
    on: {
      "input": _vm.setChannelInfo
    },
    model: {
      value: (_vm.channel.channelSelected),
      callback: function($$v) {
        _vm.channel.channelSelected = $$v
      },
      expression: "channel.channelSelected"
    }
  }), _vm._v(" "), (_vm.$v.channel.channelSelected && _vm.$v.channel.channelSelected.$invalid) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\t\tEl canal es requerido\n\t\t\t\t")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-2": ""
    }
  }, _vm._l((_vm.typeChannelSelected.fields), function(field, fieldIndex) {
    return _c('v-flex', {
      key: fieldIndex,
      attrs: {
        "xs4": "",
        "md3": "",
        "text-xs-left": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v(_vm._s(field.label))]), _vm._v(" "), _c(field.type, {
      tag: "component",
      class: {
        'filter-select filter-select-autocomplete':
        field.type === 'v-select',
          'input-border-inset': field.type === 'v-text-field'
      },
      attrs: {
        "item-text": field.items.itemText,
        "item-value": field.items.itemValue,
        "items": field.items.name,
        "autocomplete": field.type === 'v-select'
      },
      model: {
        value: (field[field.value]),
        callback: function($$v) {
          _vm.$set(field, field.value, $$v)
        },
        expression: "field[field.value]"
      }
    })], 1)
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5254e15a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/shared/ChannelComponent.vue
// module id = 1635
// module chunks = 20